import { Box, Typography } from "@mui/material";

export default function AboutPage() {
  return (
    <section id="about">
      <Box display="flex">
        <Box width={{ xs: "100%", md: "50vw" }}>
          <Typography
            variant="h2"
            fontFamily="Canopee"
            sx={{ fontSize: { xs: "5.25rem", md: "100px" } }}
          >
            About
          </Typography>

          <Typography variant="h5" my={4} fontFamily="Canopee">
            I'm Polina. I build cool things for the web.
          </Typography>

          <Typography variant="body2" fontFamily="Aktiv">
            I'm a full stack engineer building reliable, thoughtful web systems.
            I work across Ruby on Rails and Node on the backend, and React with
            TypeScript on the frontend. I design applications that are both
            technically sound and intuitive to use.
          </Typography>

          <Typography variant="body2" my={4} fontFamily="Aktiv">
            I enjoy operating across the stack: designing APIs and data models,
            building background job pipelines, shaping database schemas, and
            implementing clean, maintainable frontend architectures. I care
            deeply about system reliability, performance, and long-term
            maintainability.
          </Typography>

          <Typography variant="body2" fontFamily="Aktiv">
            With a foundation in product and UX, I approach engineering
            holistically, thinking in systems and building software that
            balances architecture, usability, and real-world impact.
          </Typography>
        </Box>
      </Box>
    </section>
  );
}
